import { initializeApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth'; // ✅ Importar getAuth

// Configuración CORRECTA - usa el storageBucket de tu proyecto
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar servicios
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app); // ✅ Inicializar auth

// ✅ AGREGAR PERSISTENCIA OFFLINE (solo para Firestore)
enableIndexedDbPersistence(db)
  .then(() => {
    console.log('✅ Persistencia offline habilitada para Firestore');
  })
  .catch((err) => {
    if (err.code === 'failed-precondition') {
      console.log('⚠️ Persistencia falló: Múltiples pestañas abiertas');
    } else if (err.code === 'unimplemented') {
      console.log('⚠️ Persistencia no soportada en este navegador');
    } else {
      console.log('❌ Error de persistencia:', err);
    }
  });

export default app;
